import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { AnyDate, DateFormats, formatDate, parseDate } from '../../helpers/dateHelper'
import { Text, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

type Props = {
    date: AnyDate
    format?: DateFormats
    className?: string
}

export default function FormattedDate(props: Props): ReactElement {
    const { i18n } = useTranslation()

    const dateString = useMemo(() => formatDate(props.date, { locale: i18n.language }), [i18n.language])
    const tooltipString = useMemo(
        () => parseDate(props.date, { locale: i18n.language })?.toFormat(props.format || DateFormats.Full) || '',
        [i18n.language],
    )

    return (
        <Tooltip relationship={'label'} content={tooltipString} withArrow>
            <Text size={200} className={props.className}>
                {dateString}
            </Text>
        </Tooltip>
    )
}
